/**
 * Корневой route. Просто рендерит <Outlet />.
 * Auth-провайдер и Theme-провайдер находятся выше, в App.tsx.
 */

import { createRootRoute, Outlet } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: () => <Outlet />,
});
